// TODO: Need to handle the case when the stationList is empty.
// Right now it's displaying "[]".

import React, { useEffect } from "react";
import { StationViewModel } from "@dining/api-client";
import { appInsightsEvents, trackEvent, useAppStore } from "../../../../common";
import { useStyles } from "./StationListStyles";
import { StationCard } from "../StationCard";

interface StationListProps {
  stations: StationViewModel[];
  cafeId: string;
}

export const StationList = ({ stations, cafeId }: StationListProps) => {
  const context = useAppStore((state) => state.context);
  const appInsights = useAppStore((state) => state.appInsights);
  const styles = useStyles();
  useEffect(() => {
    trackEvent(appInsights, appInsightsEvents.Usage.ViewComponent, context, {
      componentName: "StationList",
      cafeId,
      stationCount: stations.length,
    });
  }, [appInsights, context, cafeId, stations]);

  return (
    <div data-testid="stationList" className={styles.container}>
      {stations.map((station) => (
        <StationCard key={station.id} station={station} cafeId={cafeId} />
      ))}
    </div>
  );
};
